import type { FanWallStickerDefinition } from "./fanWallTypes";

export const FAN_WALL_STICKER_CATALOG: FanWallStickerDefinition[] = [
  {
    type: "flower",
    label: "Flower",
    price: 5,
    emoji: "🌸",
    accent: "#e891b8",
    orbGradient:
      "radial-gradient(circle at 35% 25%, #fff0f7 0%, #f9c8e2 42%, #e8a0c8 100%)",
  },
  {
    type: "crown",
    label: "Crown",
    price: 25,
    emoji: "👑",
    accent: "#c9a84c",
    orbGradient:
      "radial-gradient(circle at 35% 25%, #fefce8 0%, #fae38a 42%, #e8c96a 100%)",
  },
  {
    type: "mic",
    label: "Mic Drop",
    price: 20,
    emoji: "🎤",
    accent: "#8a80d8",
    orbGradient:
      "radial-gradient(circle at 35% 25%, #f4f0ff 0%, #cfc8f8 42%, #b0a6ee 100%)",
  },
  {
    type: "rose",
    label: "Rose",
    price: 15,
    emoji: "🌹",
    accent: "#e07090",
    orbGradient:
      "radial-gradient(circle at 35% 25%, #fff0f4 0%, #f8bdd0 42%, #eca8bc 100%)",
  },
  {
    type: "fire",
    label: "Fire",
    price: 10,
    emoji: "🔥",
    accent: "#e0834a",
    orbGradient:
      "radial-gradient(circle at 35% 25%, #fff5ee 0%, #fcd0a8 42%, #f0a870 100%)",
  },
  {
    type: "star",
    label: "Star",
    price: 15,
    emoji: "⭐",
    accent: "#d4a72c",
    orbGradient:
      "radial-gradient(circle at 35% 25%, #fffde8 0%, #fbeea0 42%, #f0d06a 100%)",
  },
  {
    type: "heart",
    label: "Heart",
    price: 30,
    emoji: "💖",
    accent: "#e87090",
    orbGradient:
      "radial-gradient(circle at 35% 25%, #fff0f2 0%, #f9b8c8 42%, #e88aa4 100%)",
  },
  {
    type: "candy",
    label: "Candy",
    price: 20,
    emoji: "🍬",
    accent: "#d4709a",
    orbGradient:
      "radial-gradient(circle at 35% 25%, #fff0f8 0%, #f8c0dc 45%, #e898c0 100%)",
  },
  {
    type: "teddy",
    label: "Teddy",
    price: 10,
    emoji: "🧸",
    accent: "#c49a6c",
    orbGradient:
      "radial-gradient(circle at 35% 25%, #fdf6ee 0%, #f0d8b8 45%, #deb888 100%)",
  },
  {
    type: "coffee",
    label: "Coffee",
    price: 5,
    emoji: "☕",
    accent: "#c89a52",
    orbGradient:
      "radial-gradient(circle at 35% 25%, #fffaf0 0%, #fde6b0 45%, #e8c07a 100%)",
  },
];

export const FAN_WALL_MESSAGE_ONLY_PRICE = 1;

export const getStickerByType = (type: string) =>
  FAN_WALL_STICKER_CATALOG.find((s) => s.type === type);

export const getStickerByPrice = (price: number) =>
  FAN_WALL_STICKER_CATALOG.find((s) => s.price === price);

export const getGiftEmojiByPrice = (price: number) =>
  getStickerByPrice(price)?.emoji ?? "🎁";

export const FAN_WALL_PLACEHOLDER_THUMB =
  "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=400&h=240&fit=crop";
